import { Link } from "react-router-dom";
import MelonCard from "@/components/feature/MelonCard";
import type { Melon } from "@/types/content";

interface MelonGridProps {
  melons: Melon[];
  visibleCount: number;
  onLoadMore: () => void;
}

export default function MelonGrid({ melons, visibleCount, onLoadMore }: MelonGridProps) {
  if (melons.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-foreground-500">
          <i className="ri-search-eye-line text-2xl" aria-hidden="true"></i>
        </span>
        <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
          这个角落暂时还没瓜
        </h3>
        <p className="mt-2 max-w-sm text-sm text-foreground-600">
          换个关键词或者切到其它分类看看，新内容每天都在补，蹲一会儿就有了。
        </p>
        <Link
          to="/plaza"
          className="mt-5 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
        >
          重置筛选
          <i className="ri-refresh-line text-base" aria-hidden="true"></i>
        </Link>
      </div>
    );
  }

  const visibleMelons = melons.slice(0, visibleCount);
  const hasMore = visibleCount < melons.length;

  return (
    <div>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        {visibleMelons.map((melon) => (
          <MelonCard key={melon.id} melon={melon} />
        ))}
      </div>
      {hasMore && (
        <div className="mt-8 flex justify-center">
          <button
            type="button"
            onClick={onLoadMore}
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-300 px-6 py-3 text-sm font-medium text-primary-800 transition-colors hover:bg-primary-100"
          >
            加载更多内容
            <i className="ri-arrow-down-line text-base" aria-hidden="true"></i>
          </button>
        </div>
      )}
    </div>
  );
}